<template>
  <main>
    <!-- <h6 class="mt-4">{{ $t("lang.label.target") }}</h6> -->
    <LoadingSpinner v-if="!completeLoading" />
    <div class="row" v-if="completeLoading">
      <div class="col-sm-6" v-for="(target, index) in targets" :key="index">

        <div class="card p-4 mt-4">
          <div>
            <h5 class="">
              <span>
                <i :class="getClassStatus(target)"></i>
              </span>
              <span v-if="showFull && target.target_status_id == 1">
                <i :class="getClasssWarning(target, true)"></i>
              </span>
              {{ target.name }}
              <span v-if="showFull">
                <button
                  class="btn btn-sm btn-success"
                  @click="getApollo(target.data)">
                  <i class="icon-list"></i></button>
                <span
                  class="small ml-2"
                  v-if="target.apollo_total_contacts > 0">
                  {{ target.apollo_total_contacts }}</span>
                  
              </span>
              <span v-if="showFull" class="float-right">
              
                <router-link
                           
                            :to="'/orders/'+target.id"
                  >
                   <i
                  class="icon-edit cursor-pointer mr-0"
                  @click="editItem('model.targets', index, 'currentTarget')"
                ></i>
                </router-link>

              </span>
            </h5>

            <h6 class="mt-4">{{ $t("lang.label.industry") }}</h6>
            <IndustrySearch
              v-if="
                hierarchyoptionsGoogleAll !== null &&
                hierarchyoptionsGoogleAll !== undefined
              "
              :option_list="hierarchyoptionsGoogleAll.data"
              :default_values="target.data.categories_industry"
              :isDisabled="true"
            >
            </IndustrySearch>

            <h6 class="mt-4">{{ $t("lang.label.jobtitle") }}</h6>
            <p class="p-2">
              <b>{{ $t("lang.search.isanyof") }}: </b>
              <span
                v-for="(tag, ti) in target.data.categories_jobs.anyof"
                :key="ti"
              >
                {{ tag.word }},
              </span>
            </p>
            <p class="p-2">
              <b>{{ $t("lang.search.isnotanyof") }}: </b>
              <span
                v-for="(tag, ti) in target.data.categories_jobs.notanyof"
                :key="ti"
              >
                {{ tag.word }},
              </span>
            </p>

            <h6 class="mt-4">{{ $t("lang.label.companysize") }}</h6>
            <div
              v-if="
                target.data.employees != undefined &&
                target.data.employees.keywords != undefined
              "
            >
              <span v-if="target.data.employees.keywords.greater != undefined">
                {{ $t("lang.label.morethan") }} :
                {{ target.data.employees.keywords.greater }}</span
              >
              |
              <span
                v-if="
                  target.data.employees != undefined &&
                  target.data.employees.keywords.less != undefined
                "
              >
                {{ $t("lang.label.lessthan") }} :
                {{ target.data.employees.keywords.less }}</span
              >
            </div>

            <h6 class="mt-4">{{ $t("lang.search.companylocation") }}</h6>
            <IndustrySearch
              v-if="hierarchyoptions !== null && hierarchyoptions !== undefined"
              :option_list="hierarchyoptions.data"
              :default_values="target.data.region"
              :isDisabled="true"
            >
            </IndustrySearch>

            <h6 class="mt-4">{{ $t("lang.label.hierarchicallevel") }}</h6>
            <IndustrySearch
              v-if="
                hierarchyoptionsSearchLevel !== null &&
                hierarchyoptionsSearchLevel !== undefined
              "
              :option_list="hierarchyoptionsSearchLevel.data"
              :default_values="target.data.categories_level"
              :isDisabled="true"
            >
            </IndustrySearch>

            <h6 class="mt-4">{{ $t("lang.label.sector") }}</h6>
            <IndustrySearch
              v-if="hierarchyoptionsSearchFunction !== null"
              :option_list="hierarchyoptionsSearchFunction.data"
              :default_values="target.data.categories_function"
              :isDisabled="true"
            >
            </IndustrySearch>
            <h6 class="mt-4">{{ $t("lang.column.contactcountry") }}</h6>
            <IndustrySearch
              v-if="
                hierarchyoptionsCountry !== undefined &&
                hierarchyoptionsCountry !== null
              "
              :option_list="hierarchyoptionsCountry.data"
              :default_values="target.data.countries"
              :isDisabled="true"
            >
            </IndustrySearch>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="mt-4" :class="getClasssWarning(target, false)">
                <small>Target ID: {{target.id}}</small><br>
                <small>Total:  {{ parseInt(target.apollo_total_contacts) }} </small>
                <div class="progress mb-4" style="height: 100%;">
                  <div class="progress-bar" :class="getColor(target)" role="progressbar" :style="'width:'+getPercentage(target)+'%;'">
                                    Processed: {{
                    parseInt(target.apollo_actual_page) * 10 >
                    parseInt(target.apollo_total_contacts)
                      ? parseInt(target.apollo_total_contacts)
                      : parseInt(target.apollo_actual_page) * 10
                  }} ({{getPercentage(target)}}%)


                  <div class="progress-bar bg-primary pl-2" role="progressbar" :style="'width:'+getPercentageImported(target)+'%;'">
                           Imported: {{target.imported}}  ({{getPercentageImported(target)}}%) </div></div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div v-if="showFull" class="text-right mt-4">
                <div v-for="(row, user_id) in campaigns" class="overflow-auto">
                  <ItemMonitor
                    v-if="user_id !== null"
                    :stats="campaigns"
                    :type="'campaigns'"
                    :ref="user_id"
                    :user_id="user_id"
                    :target_id="target.id"
                  ></ItemMonitor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Modal from "@/components/Common/Modal.vue";

import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  props: {
    targets: Array,
    showFull: {
      type: Boolean,
      required: false,
      default: false,
    },
    campaigns: {
      type: Object,
      required: false,
      default: {},
    },
  },
  data() {
    return {
      list: [],
      stats: [],
    };
  },
  components: { IndustrySearch, LoadingSpinner, ItemMonitor },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      completeLoading: (state) => state.optionsList.completeLoading,
      contractListLoaded: (state) => state.optionsList.contractListLoaded,
      hierarchyoptions: (state) => state.optionsList.all["regions"],
      hierarchyoptionsSearch: (state) =>
        state.optionsList.all["categories_search_words"],
      hierarchyoptionsSearchFunction: (state) =>
        state.optionsList.all["categories_search_function"],
      hierarchyoptionsSearchLevel: (state) =>
        state.optionsList.all["categories_search_level"],
      hierarchyoptionsGoogleAll: (state) =>
        state.optionsList.all["categories_google_all"],
      hierarchyoptionsCountry: (state) => state.optionsList.all["countries"],
    }),
  },
  created() {
    let options = [
      "categories_google_all",
      "regions",
      "categories_search_level",
      "categories_search_function",
      "countries",
    ];
    this.getOptionsList(options);
  },
  methods: {
    ...mapActions("optionsList", {
      getOptionsList: "getOptions",
    }),
    getPercentage(target){
        let total= 0;
        if(parseInt(target.apollo_actual_page) * 10 > parseInt(target.apollo_total_contacts)){
          total = parseInt(target.apollo_total_contacts)
        }else{
          total = parseInt(target.apollo_actual_page) * 10;
        }
        return Math.round(total*100/parseInt(target.apollo_total_contacts))
    },
    getPercentageImported(target){
        let total= 0;
        if(parseInt(target.apollo_actual_page) * 10 > parseInt(target.apollo_total_contacts)){
          total = parseInt(target.apollo_total_contacts)
        }else{
          total = parseInt(target.apollo_actual_page) * 10;
        }
        return Math.round(parseInt(target.imported)*100/total)
    },
    getColor(target){
      if(this.getPercentage(target) > 90){
        return 'bg-danger'
      }
      if(this.getPercentage(target) > 60){
        return 'bg-warning'
      }
      return 'bg-success'
      
    },
    getApollo(data) {
      this.$emit("getApollo", data);
    },
    editItem(model, index, current) {
      this.$emit("editItem", model, index, current);
    },
    removeItem(model, index) {
      this.$emit("removeItem", model, index);
    },
    copyItem(index) {
      this.$emit("copyItem", index);
    },
    getClassStatus(target) {
      if (target.target_status_id == 1) {
        return "icon-play text-primary mr-2";
      } else if (target.target_status_id == 2) {
        return "icon-stop text-danger mr-2";
      } else if (target.target_status_id == 3) {
        return "icon-stop text-secondary  mr-2";
      }
    },
    getClasssWarning(target, icon) {
      let iconClass = "";

      if (
        target.campaigns_info !== undefined &&
        target.campaigns_info.active_campaigns > 0
      ) {
        if (
          target.apollo_total_contacts > 0 &&
          target.apollo_total_contacts - target.apollo_actual_page * 10 <= 0
        ) {
          if (icon) {
            iconClass = "icon-warning ";
          }
          return iconClass + "text-warning";
        } else {
          if (icon) {
            iconClass = "icon-circle ";
          }
          return iconClass + "text-success";
        }
      } else if (
        target.campaigns_info !== undefined &&
        target.campaigns_info.total_campaigns > 0 &&
        (target.apollo_total_contacts == 0 ||
          target.apollo_total_contacts == null ||
          target.apollo_total_contacts - target.apollo_actual_page * 10 > 0)
      ) {
        if (icon) {
          iconClass = "icon-circle ";
        }
        return iconClass + "text-success";
      }

      if (icon) {
        iconClass = "icon-circle ";
      }
      return iconClass + "text-secondary";
    },
  },
  watch: {},
};
</script>